module.exports = __webpack_public_path__ + "img/thumbnail_SouthernWhiteRhino_m_normal.24757669.png";